export default "__VITE_ASSET__CtFxGZJT__"